"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _Validator = require("./classes/Validator");

var rules = _interopRequireWildcard(require("./rules"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _v = rules;
var VueClockwork = {
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    Vue.mixin({
      data: function data() {
        return {
          validator: null
        };
      },
      methods: {
        initValidator: function initValidator() {
          var sfc = this;
          this.validator = new _Validator.Validator();
          this.validator.setComponentInstance(sfc);
        },
        hasError: function hasError(dataKey) {
          if (!this.validator.errorsBag) return false;
          var errors = this.validator.errorsBag.filter(function (error) {
            return error.dataKey === dataKey;
          });
          return !!errors.length;
        },
        showError: function showError(dataKey) {
          if (!this.validator.errorsBag) {
            window.console.log('no errors to display');
            return null;
          }

          var errors = this.validator.errorsBag.filter(function (error) {
            return error.dataKey === dataKey;
          });
          return errors.length ? errors[0].message : null;
        }
      }
    });
  }
};
module.exports = {
  _v: _v,
  VueClockwork: VueClockwork
};